export enum GameSide {
    Home = 1,
    Away = 2,
}
